import React from 'react'
import { DropDownList } from '@/components/dropDownList'

export default class MultiSelect extends React.Component {
  render () {
    const { dataSource } = this.props
    if (typeof dataSource !== 'undefined') {
      const { value, textField, dataItemKey, name, onChange } = this.props
      return <DropDownList
        dataSource={dataSource}
        name={name}
        textField={textField || 'name'}
        valueField={dataItemKey || 'id'}
        value={value}
        onChange={onChange}
        mode='multiple' />
    }

    return <DropDownList {...this.props} mode='multiple' />
  }
}



// WEBPACK FOOTER //
// ./src/components/MultiSelect/MultiSelect.js